import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import axios from "../../axios-bdp-http";
import { Box } from "@mui/material";

export function AddressInput(props) {
    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);
    const [respLoading, setRespLoading] = useState(false);
    const [options, setOptions] = useState([]);

    const getAddress = async (address) => {
        try {
            const payLoad = {
                ServiceProviderName: process.env.REACT_APP_SERVICE_PROVIDER_NAME,
                Address: address,
            };
            const resp = await axios("").post("/srw/v1/customerLocationAddresses", JSON.stringify(payLoad));
            return resp?.data?.lstCustomerAddresses;
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (inputValue === "") {
            setOptions(props?.value ? [props?.value] : []);
            return undefined;
        }
        if (inputValue.length > 2) {
            setRespLoading(true);
            const identifier = setTimeout(() => {
                console.log("Calling API");
                const getData = getAddress(inputValue);
                getData.then((res) => {
                    setOptions(() => res);
                    setRespLoading(false);
                }).catch((err) => {
                    console.log(err);
                    setRespLoading(false);
                });
            }, 1000);
            return () => {
                clearTimeout(identifier);
                setOptions(() => []);
            }
        }
        // setRespLoading(false);
    }, [inputValue]);

    useEffect(() => {
        if (!open) {
            setOptions(() => []);
        }
    }, [open]);

    return (
        <Autocomplete
            id="id_streetAddress"
            getOptionLabel={(option) =>
                typeof option === "string"
                    ? option
                    : `${option.HouseNumber} ${option.StreetName} ${option.UnitNumber ? option.UnitNumber : ""
                    }`
            }
            options={options}
            value={props?.value}
            isOptionEqualToValue={(optionA, optionB) =>
                optionA.StreetName === optionB.StreetName
            }  
            noOptionsText="No locations"
            renderOption={(props,options) => (
                <Box component="li" {...props} key={options.li}>
                    {options.HouseNumber} {options.StreetName} {options.UnitNumber ? options.UnitNumber : ""}
                </Box>
            )}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            loading={respLoading}
            onChange={(event, newValue) => props?.onChangeEvent(newValue)}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue.trim());
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Street address"
                    helperText="House number and Street name"
                    required
                />
            )}
        />
    );
}